module.exports = __webpack_public_path__ + "static/media/a4.90f47cc0.jpg";